import { BalanceBudgetGiftProcedure } from 'components/admin-portal/Procedures/LeaveProcedures/components/BalanceBudgetGiftProcedure';
import {
  GridContainer,
  GridCompact4
} from 'components/shared/Grid/Grid.components';
//import { YearOverLeaveProcedure } from 'components/admin-portal/Procedures/LeaveProcedures/components/YearOverLeaveProcedure';

export const LeaveProcedures = () => {
  return (
    <GridContainer>
      <GridCompact4>
        <BalanceBudgetGiftProcedure />
      </GridCompact4>
    </GridContainer>
  );
};
